export function testimonialsSlider() {
    const slider = $('.testimonials-slider');
    let activeSlide = slider.parent().find('.active-slide');
    let totalSlides = slider.parent().find('.total-slides');
    let items = slider.find('.slide').length;

    let setCounter = function (activeNumber) {
        activeSlide.html(activeNumber);
        totalSlides.html(items);
    };

    if (items > 1) {
        setCounter(1);
        slider.slick({
            slidesToScroll: 1,
            fade: true,
            infinite: false,
            prevArrow: $('.slider-controls .slick-prev'),
            nextArrow: $('.slider-controls .slick-next'),
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            activeSlide.text(nextSlide + 1);
        })
    } else {
        $(".slider-controls-wrap .slider-controls").hide();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js